<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <LoadCard v-if="load"></LoadCard>

        <Bar v-else :data="datacollection" :options="options" :width="width" :height="height" ref="barChart"></Bar>
    </div>
</template>
<script>
//grafica
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

//signal R
import { hub } from '@/plugins/signalR/index';

import { ReceiveHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

//alerta, tonos de color, modal, load
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import tinycolor from 'tinycolor2'
import LoadCard from '@/components/shared/Load-card.vue'
import config from '@/plugins/config'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

export default {
    name: 'NotificationCountGraph',

    components: {
        Bar,
        AlertDismiss,
        LoadCard
    },

    mixins: [dashboardGraph],

    data() {
        return {
            datacollection: {
                labels: ['Notificación de documentos', 'Notificación de denuncias', 'Notificación de declaraciones'],
                datasets: [
                    {
                        label: 'Notificaciones',
                        backgroundColor: '',
                        data: []
                    }
                ]
            },

            options: {
                responsive: true,
                maintainAspectRatio: false
            },

            load: true,
            sentDocumentCount: null,
            countSendDenunciation: null,
            countSendStatement: null,

            hasSentDocumentCount: false,
            hasCountSendDenunciation: false,
            hasCountSendStatement: false,

            connectionSendDocument: null,
            connectionSentDenunciation: null,
            connectionSentStatement: null,
        }
    },

    props: {
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 200
        },
    },

    async created() {
        this.connectionSendDocument = hub.getInstance(namesHub.sendDocumentHub)
        await this.connectionSendDocument.start();

        this.connectionSentDenunciation = hub.getInstance(namesHub.sendDenunciationHub)
        await this.connectionSentDenunciation.start();

        this.connectionSentStatement = hub.getInstance(namesHub.sendStatementHub)
        await this.connectionSentStatement.start();

        //signal R on
        this.countSendDocumentsSignalROn(this.connectionSendDocument);
        this.countSendDenunciationSignalROn(this.connectionSentDenunciation);
        this.countSendStatementSignalROn(this.connectionSentStatement);
    },

    beforeDestroy() {
        this.connectionSendDocument.off(ReceiveHubs.countSendDocument, null);
        this.connectionSentDenunciation.off(ReceiveHubs.countSendDenunciations, null);
        this.connectionSentStatement.off(ReceiveHubs.countSendStatements, null);
    },

    methods: {
        countSendDocumentsSignalROn(connection) {
            connection.on(ReceiveHubs.countSendDocument, (count) => {
                try {
                    if (this.getGraph.mixinItUpdates) { this.sentDocumentCount = count }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica de notificaciones.");
                }
            });
        },

        countSendDenunciationSignalROn(connection) {
            connection.on(ReceiveHubs.countSendDenunciations, (count) => {
                try {
                    if (this.getGraph.mixinItUpdates) { this.countSendDenunciation = count }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica de notificaciones.");
                }
            });
        },

        countSendStatementSignalROn(connection) {
            connection.on(ReceiveHubs.countSendStatements, (count) => {
                try {
                    if (this.getGraph.mixinItUpdates) { this.countSendStatement = count }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica de notificaciones.");
                }
            });
        },

        //generar colores
        generateColorShades(baseColor, numShades) {
            const shades = []
            const color = tinycolor(baseColor)

            for (let i = 0; i < numShades; i++) {
                const shade = color.clone().lighten(i * 10).toString()
                shades.push(shade)
            }

            return shades
        },

        //actualizar data sets
        setChartData(data, colors) {
            this.datacollection = {
                labels: ['Notificación de documentos', 'Notificación de denuncias', 'Notificación de declaraciones'],

                datasets: [
                    {
                        label: 'Notificaciones',
                        backgroundColor: colors,
                        data: data
                    }
                ]
            }

        },

        //si sentDocumentCount Y countSendDenunciation campian entonces ejecutar esto
        checkVariablesChanged() {
            if (this.hasSentDocumentCount && this.hasCountSendDenunciation && this.hasCountSendStatement) {
                this.onVariablesChanged();
                this.resetFlags();
            }
        },

        //logica si cambian sentDocumentCount Y countSendDenunciation
        onVariablesChanged() {
            let count = [this.sentDocumentCount, this.countSendDenunciation, this.countSendStatement];
            let colors = this.generateColorShades(config.theme.menuBackgroundColor, count.length);

            this.setChartData(count, colors);
            this.load = false;
        },

        resetFlags() {
            this.hasSentDocumentCount = false;
            this.hasCountSendDenunciation = false;
            this.hasCountSendStatement = false;
        }
    },

    watch: {
        'sentDocumentCount'() {
            this.hasSentDocumentCount = true;
            this.checkVariablesChanged();
        },

        'countSendDenunciation'() {
            this.hasCountSendDenunciation = true;
            this.checkVariablesChanged();
        },
        'countSendStatement'() {
            this.hasCountSendStatement = true;
            this.checkVariablesChanged();
        }
    }
}
</script>
<style></style>